import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const customKubernetesPlugin = createPlugin({
  id: 'custom-kubernetes',
  routes: {
    root: rootRouteRef,
  },
});

export const CustomEntityKubernetesContent = customKubernetesPlugin.provide(
  createRoutableExtension({
    name: 'CustomEntityKubernetesContent',
    component: () => import('./Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
